<template>
  <div class="content-presence">
    <div>
      <b-card>
        <h6 class="mb-4 font-weight-bold">Filter</h6>
        <b-row>
          <b-col>
            <b-form-group
              label="Month(s)"
            >
              <custom-select
                label="name"
                v-model="filterMonth"
                :options="monthFilter.filters"
                placeholder="Select month"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Year(s)">
              <custom-select
                label="year"
                v-model="filterYear"
                :options="yearFilter.filters"
                placeholder="Select year"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <div class="button-project mt-5 d-flex justify-content-end">
          <b-button
            class="reset mr-3"
            variant="outline-warning"
            @click="resetFilter"
          >
            Reset Filter
          </b-button>
          <b-button
            class="next"
            variant="warning"
            @click="applyFilter"
          >
            Apply Filter
          </b-button>
        </div>
      </b-card>
    </div>
    <div class="mt-3">
      <b-card>
        <div class="upper-button text-white d-flex justify-content-between">
          <div>
            <b-button v-show="!attendanceEmployees.length" variant="warning" @click="openModalCreateAttendance">
              Create New Presence
            </b-button>
            <b-button v-show="attendanceEmployees.length" variant="warning" @click="openModalAllEmployeePresent">
              All Employee Present
            </b-button>
          </div>
          <div class="d-flex justify-content-center">
            <b-button class="button-recap mr-3" variant="warning" @click="goToRecapAttendance">
              Recap Attendance
            </b-button>
            <b-button class="button-graphic" variant="warning" @click="goToGraphicStatistic">
              Graphic Statistic
            </b-button>
            <b-button class="ml-3" variant="warning" @click="refreshDataTable">
              <b-icon icon="arrow-clockwise" font-scale="1.2"/>
              <span v-show="showDotNotif" class="red-dot"></span>
            </b-button>
          </div>
          <modal-all-employee-present @allPresent="allEmployeePresent" />
        </div>
        <div>
          <b-row v-show="!attendanceEmployees.length">
            <b-col>
              <div align="center">
              <img src="@/assets/icon-no-invoice.png"/>
            </div>
            </b-col>
          </b-row>
          <b-table
            ref="table"
            class="table-employees mt-2 text-center align-middle"
            v-show="attendanceEmployees.length"
            :fields="fields"
            :items="getAttendance"
            :per-page="perPage"
            :current-page="currentPage"
            responsive
            striped
          >
            <template #cell(no)="{ index }">
              <div>
                {{ index + 1 }}
              </div>
            </template>
            <template #cell(percentage)="data">
              <div>
                {{ data.item.percentage }} %
              </div>
            </template>
            <template #cell(action)="data">
              <div>
                <b-link>
                  <b-icon
                    v-show="showPresenceButton"
                    icon="check2-square"
                    class="check mr-2 text-secondary"
                    @click="openModalAttendance(data.item)"
                  />
                </b-link>
                <b-link>
                  <fa-icon
                    v-show="showPresenceButton"
                    icon="edit"
                    class="mr-2 text-secondary"
                    @click="openModalUpdateAttendance(data.item)"
                  />
                </b-link>
                <b-link>
                <fa-icon
                    @click="openModalViewReportAttendanceEmployee(data.item)"
                    icon="eye"
                    class="mr-2 text-secondary"
                  />
                </b-link>
              </div>
            </template>
          </b-table>
        </div>
        <div class="d-flex justify-content-between">
          <div>
            <span>Show</span>
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
              @change="$refs.table.refresh()"
              class="page-option ml-2 mr-2 w-auto"
              size="sm"
            />
            <span>Entries</span>
          </div>
          <div>
            <b-pagination
              class="mb-0"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              pills
              hide-goto-end-buttons
            />
            <span class="show-entries mr-auto">
              {{
              `Show ${
                totalRows === 0 ? 0 : (currentPage - 1) * perPage + 1
              } to ${
                totalRows > currentPage * perPage
                  ? currentPage * perPage
                  : totalRows
              } of ${totalRows} entries`
            }}
            </span>
          </div>
        </div>
      </b-card>
    </div>
    <div>
      <modal-create-attendance
        @create="createAttendancePerMonth"
      />
    </div>
    <div>
      <modal-attendance
        :typeAttendance="attendanceType"
        :presence="targetEmployeeAttendance"
        :dataAttendance="dataAttendanceUpdate"
        :month="convertStringMonthToNumber(filterMonth)"
        @save="attendance"
      />
    </div>
    <div>
      <modal-update-attendance
        :typeAttendance="attendanceType"
        :presence="targetEmployeeAttendance"
        :dataAttendance="dataAttendanceUpdate"
        :attendanceMontly="employeeAttendancePerMonth"
        :month="convertStringMonthToNumber(filterMonth)"
        @update="updateDetailAttendance"
      />
    </div>
    <div>
      <modal-view-report-attendance-employee
        :typeAttendance="attendanceType"
        :employee="singleEmployee"
        :attendanceMontly="employeeAttendancePerMonth"
      />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import ModalCreateAttendance from './ModalCreateAttendancePerMonth'
import ModalAttendance from './ModalPresence'
import ModalAllEmployeePresent from './ModalAllEmployeePresent'
import ModalViewReportAttendanceEmployee from './ModalViewAttendanceEmployee'
import ModalUpdateAttendance from './ModalUpdateAttendance'

export default {
  components: {
    ModalCreateAttendance,
    ModalAttendance,
    ModalAllEmployeePresent,
    ModalViewReportAttendanceEmployee,
    ModalUpdateAttendance
  },
  data: () => ({
    employee: [],
    singleEmployee: {},
    attendanceEmployees: [],
    allAttendanceEmployee: [],
    allDetailAttendance: [],
    targetEmployeeAttendance: {
      attendanceId: '',
      name: '',
      employeeNo: '',
      position: ''
    },
    dataAttendanceUpdate: {},
    employeeAttendancePerMonth: [],
    listScoreAttendance: [],
    statusAttendance: [],
    attendanceType: [],
    filterMonth: [],
    monthFilter: {
      show: true,
      filters: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'Desember'
      ]
    },
    filterYear: new Date().getFullYear(),
    yearFilter: {
      show: true,
      filters: []
    },
    realTimeMonth: new Date().getMonth() + 1,
    currentPage: 1,
    perPage: 10,
    totalRows: 0,
    totalPage: 0,
    pageOptions: [10, 20, 50, 100],
    fields: [
      { key: 'no', label: 'No', thClass: 'text-center align-middle vertical-baseline', tdClass: 'text-center align-middle vertical-baseline' },
      { key: 'name', label: 'Name', thClass: 'text-center align-middle vertical-baseline', tdClass: 'text-center align-middle vertical-baseline' },
      { key: 'month', label: 'Month', tdClass: 'text-center', thClass: 'text-center' },
      { key: 'year', label: 'Year', tdClass: 'text-center', thClass: 'text-center' },
      { key: 'target', label: 'Target', tdClass: 'text-center', thClass: 'text-center' },
      { key: 'realization', label: 'Realization', tdClass: 'text-center', thClass: 'text-center' },
      { key: 'percentage', label: 'Percentage', tdClass: 'text-center', thClass: 'text-center' },
      { key: 'status', label: 'Status', tdClass: 'text-center', thClass: 'text-center' },
      { key: 'action', label: 'Action', tdClass: 'text-center', thClass: 'text-center' }
    ],
    isBusy: false,
    modeUpdate: false,
    realization: 0,
    showPresenceButton: true,
    allEmployeePresentHasSave: false,
    showDotNotif: false
  }),
  methods: {
    async getAttendance() {
      try {
        const { data } = await api.presence.list({
          page: this.currentPage,
          pageSize: this.perPage,
          Filters: `Month==${this.filterMonth}, Year==${this.filterYear}`
        })
        this.attendanceEmployees = []
        data.data.forEach((item) => {
          this.employee.forEach(employee => {
            if (item.employeeId === employee.id) {
              this.attendanceEmployees.push({
                id: item.id,
                name: employee.fullName,
                employeeNo: employee.employeeNo,
                position: employee.position,
                month: item.month,
                year: item.year,
                target: item.target,
                realization: item.realization,
                percentage: parseFloat(item.percentage).toFixed(2),
                status: item.status
              })
            }
          })
        })
        this.totalRows = data.length !== 0 ? data.totalData : 0
        this.totalPage = data.totalPage
      } catch (error) {
        console.log(error)
      }
      this.attendanceEmployees.map((employee, i) => {
        employee._rowVariant = i % 2 === 0 ? 'warning' : ''
      })
      return this.attendanceEmployees
    },
    async getEmployee() {
      try {
        const { data } = await api.employee.list({
          page: 1,
          pageSize: 1000,
          Filters: 'status==true'
        })
        this.employee = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async getTypeAttendanceEmployee() {
      try {
        const { data } = await api.presence.getTypeAttendance()
        this.attendanceType = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async createAttendancePerMonth(data) {
      const promise = []
      this.isBusy = true
      try {
        for (const employee of this.employee) {
          const payload = {
            target: parseInt(data.target),
            employeeId: employee.id,
            month: data.month,
            year: data.year
          }
          promise.push(api.presence.createAttendance(payload))
        }
        if (promise.length === 0) {
          this.isBusy = false
          this.result('Create attendance failed', 'danger')
          return
        }
        await Promise.all(promise)
        this.result('Create attendance success', 'success')
        this.isBusy = false
        this.$refs.table.refresh()
      } catch (error) {
        this.isBusy = false
        console.log(error)
        this.result('Create attendance failed', 'danger')
      }
    },
    async getDetailByFilter(id) {
      try {
        const { data } = await api.presence.listDetail({
          page: 1,
          pageSize: 1,
          Filters: `attendanceId==${id}, attendanceDate==${this.getCurrentFormattedDate()}`
        })
        this.dataAttendanceUpdate = data.data[0]
      } catch (error) {
        console.log(error)
      }
    },
    async getAllDetailByCurrentDate() {
      try {
        const { data } = await api.presence.listDetail({
          page: 1,
          pageSize: 100000,
          Filters: `attendanceDate==${this.getCurrentFormattedDate()}`
        })
        this.allDetailAttendance = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async getDetailAttendanceEmployeeMonthly(id) {
      const month = this.convertStringMonthToNumber(this.filterMonth)
      const year = this.filterYear.toString()
      try {
        const { data } = await api.presence.listDetail({
          page: 1,
          pageSize: 30,
          Filters: `attendanceId==${id}, attendanceDate>=${year}-${month.toString().padStart(2, '0')}-01, attendanceDate<=${year}-${month.toString().padStart(2, '0')}-${this.getLastDayInMonth(this.filterYear, month).toString()}`
        })
        this.employeeAttendancePerMonth = []
        this.employeeAttendancePerMonth = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async attendance(data) {
      let result = false
      try {
        const payload = {
          attendanceId: data.attendanceId,
          attendanceTypeId: data.attendanceTypeId,
          attendanceDate: data.attendanceDate
        }
        await api.presence.attendanceEmployeeDetail(payload)
        this.result('Success save attendance', 'success')
        this.showDotNotif = true
        result = true
      } catch (error) {
        console.log(error)
      }
      if (!result) {
        this.getDetailByFilter(data.attendanceId)
        try {
          await api.presence.updateAttendanceEmployeeDetail({
            attendanceTypeId: data.attendanceTypeId
          }, this.dataAttendanceUpdate.id)
          this.showDotNotif = true
          this.result('Success update attendance', 'success')
        } catch (error) {
          console.log(error)
          this.result('Failed update attendance', 'danger')
        }
        this.dataAttendanceUpdate = {}
      }
    },
    async updateDetailAttendance(data) {
      try {
        const payload = {
          attendanceTypeId: data.attendanceTypeId
        }
        await api.presence.updateAttendanceEmployeeDetail(payload, data.attendanceDetailId)
        this.result('Success update attendance', 'success')
        this.showDotNotif = true
      } catch (error) {
        console.log(error)
        this.result('Failed update attendance', 'danger')
      }
    },
    async updateAllDetailAttendance(typeId) {
      const promises = []
      try {
        this.allDetailAttendance.forEach(item => {
          const payload = {
            attendanceTypeId: typeId
          }
          promises.push(api.presence.updateAttendanceEmployeeDetail(payload, item.id))
        })
        if (promises.length === 0) {
          this.result('Update attendance failed', 'danger')
          return
        }
        await Promise.all(promises)
        this.result('Update attendance success', 'success')
      } catch (error) {
        console.log(error)
      }
      setInterval(function() {
        location.reload()
      }, 3000)
    },
    async getAllAttendance() { // This method use for feature employee all present
      try {
        const { data } = await api.presence.list({
          page: 1,
          pageSize: 100000,
          Filters: `Month==${this.filterMonth}, Year==${this.filterYear}`
        })
        this.allAttendanceEmployee = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async allEmployeePresent() {
      let result = false
      const promises = []
      const typeAttendanceIdPresent = this.attendanceType.find(item => item.name === 'Hadir').id
      try {
        this.allAttendanceEmployee.forEach(item => {
          const payload = {
            attendanceId: item.id,
            attendanceTypeId: typeAttendanceIdPresent,
            attendanceDate: this.getCurrentFormattedDate()
          }
          promises.push(api.presence.attendanceEmployeeDetail(payload))
        })
        if (promises.length === 0) {
          this.result('Create attendance failed', 'danger')
          return
        }
        await Promise.all(promises)
        this.result('Save Attendance success', 'success')
        result = true
      } catch (error) {
        console.log(error)
      }
      if (!result) {
        this.updateAllDetailAttendance(typeAttendanceIdPresent)
      }
    },
    getCurrentFormattedDate() {
      const currentDate = new Date()
      const year = currentDate.getFullYear()
      const month = String(currentDate.getMonth() + 1).padStart(2, '0')
      const day = String(currentDate.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    convertStringMonthToNumber(monthString) {
      const month = this.monthFilter.filters.findIndex(item => item === monthString)
      return month + 1
    },
    getLastDayInMonth(year, month) {
      return new Date(year, month, 0).getDate()
    },
    formatedDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    openModalViewReportAttendanceEmployee(data) {
      this.singleEmployee = {}
      this.singleEmployee = data
      this.getDetailAttendanceEmployeeMonthly(data.id)
      this.$bvModal.show('modal-attendance-employee-perMonth')
    },
    goToRecapAttendance() {
      this.$router.push('/employee/employee-attendance-recap')
    },
    goToGraphicStatistic() {
      this.$router.push('/employee/employee-statistic-attendance')
    },
    openModalCreateAttendance() {
      this.$bvModal.show('modal-create-attendance')
    },
    openModalAttendance(data) {
      this.targetEmployeeAttendance.attendanceId = data.id
      this.targetEmployeeAttendance.name = data.name
      this.targetEmployeeAttendance.employeeNo = data.employeeNo
      this.targetEmployeeAttendance.position = data.position
      this.getDetailByFilter(data.id)
      this.$bvModal.show('modal-attendance')
    },
    openModalUpdateAttendance(data) {
      this.targetEmployeeAttendance.attendanceId = data.id
      this.targetEmployeeAttendance.name = data.name
      this.targetEmployeeAttendance.employeeNo = data.employeeNo
      this.targetEmployeeAttendance.position = data.position
      this.getDetailAttendanceEmployeeMonthly(data.id)
      this.$bvModal.show('modal-update-attendance')
    },
    openModalAllEmployeePresent() {
      this.$bvModal.show('modal-all-employee-present')
    },
    result(message, variant) {
      this.$bvToast.toast(message, {
        title: 'Result',
        variant: variant,
        solid: true
      })
    },
    applyFilter() {
      if (this.realTimeMonth !== this.convertStringMonthToNumber(this.filterMonth)) {
        this.showPresenceButton = false
      }
      this.$refs.table.refresh()
    },
    resetFilter() {
      this.filterMonth = this.monthFilter.filters[new Date().getMonth()]
      this.filterYear = new Date().getFullYear()
      this.showPresenceButton = true
      this.$refs.table.refresh()
    },
    refreshDataTable() {
      this.showDotNotif = false
      setInterval(function() {
        location.reload()
      }, 200)
    }
  },
  watch: {
    filterMonth: {
      handler() {
        this.getAllAttendance()
      },
      immediate: true
    }
  },
  created() {
    const startYear = 2022
    const currentDate = new Date()
    for (let i = startYear; i <= currentDate.getFullYear(); i++) {
      this.yearFilter.filters.push(i)
    }
    this.filterMonth = this.monthFilter.filters[currentDate.getMonth()]
    this.getEmployee()
    this.getTypeAttendanceEmployee()
    this.getAllDetailByCurrentDate()
  }
}
</script>

<style lang="scss" scoped>
*{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.check{
  font-size: 1rem;
}

.fixed-top-right {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 9999;
  width: 500px;
}

.upper-button {
  display: flex;
  justify-content: space-between;
  padding : 10px;
}

.table-employees{
  th, td{
    vertical-align: baseline !important;
  }
}

.red-dot {
  position: absolute;
  top: 27px;
  right: 70px;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
}

</style>
